import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams, useRouteLoaderData } from "react-router-dom";

import { useAppApi } from "@/App";
import { LandingBlockTypes } from "@/const";
import { useRequest } from "@components/AppHook";
import { DndTable } from "@components/DND";
import { DevForm } from "@components/Forms/Fields";
import { RenderForm } from "@components/Forms/Render";
import { Awesome, DevModal } from "@components/Helpers";
import { DefaultLayout } from "@components/Layouts";
import { ListingCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function LandingScreen() {
    const commonInfo = useRouteLoaderData("commonInfo");
    const { t } = useTranslation();
    const { slug, selection_id } = useParams();
    const apiUrl = url_reverse("api:landing:block_list", { selection_id });
    const { apiData, setApiData } = useAppApi(apiUrl);
    const [showModal, setShowModal] = useState(false);
    const [showFrontInfoModal, setShowFrontInfoModal] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (apiData) {
            const newApiData = { ...apiData };
            newApiData.forms_data.main.data.landing_id = apiData.landing_id;
            setApiData(newApiData);
        }
    }, [apiData?.forms_data]);

    if (!apiData) return;

    const addBlockModal = () => {
        return (
            <DevModal
                size="lg"
                show={showModal}
                onHide={() => setShowModal(false)}
                header={t("Добавить блок")}
                body={
                    <RenderForm
                        prefix={"main"}
                        apiData={apiData}
                        setApiData={setApiData}
                        buttons={
                            <DevForm.Button variant="primary" type="submit" name="action" value="create_block">
                                {t("Сохранить")}
                            </DevForm.Button>
                        }
                    />
                }
            />
        );
    };
    const addFrontInfoModal = () => {
        return (
            <DevModal
                size="lg"
                show={showFrontInfoModal}
                onHide={() => setShowFrontInfoModal(false)}
                header={t("Настройки лендинга")}
                body={
                    <RenderForm
                        prefix={"landing_info"}
                        apiData={apiData}
                        setApiData={setApiData}
                        afterRespOK={() => setShowFrontInfoModal(false)}
                    />
                }
            />
        );
    };

    const header = (
        <>
            <Link to={url_reverse("admin:event:items", { slug })}>{t("Управление ивентом")}</Link>
            <span> – </span>
            {t("Настройка блоков")}
        </>
    );
    const headerTools = (
        <>
            <Button onClick={() => setShowFrontInfoModal(true)} className="btn btn-sm btn-dark">
                {t("Настройки лендинга")}
            </Button>{" "}
            <Button
                href={`//${commonInfo.domain_showcase}/collections_preview/?event_slug=${slug}&selection_slug=${apiData.selection.slug}`}
                target="_blank"
                className="btn btn-sm btn-dark"
            >
                {t("Превью")}
            </Button>{" "}
            <Button onClick={() => setShowModal(true)} className="btn btn-sm btn-dark">
                <Awesome type="plus-circle" /> {t("Добавить блок")}
            </Button>{" "}
            <Button
                onClick={() => navigate(url_reverse("admin:event:landing_add_games", { slug, selection_id }))}
                className="btn btn-sm btn-dark"
            >
                <Awesome type="plus-circle" /> {t("Добавить игры")}
            </Button>
        </>
    );
    return (
        <DefaultLayout>
            <ListingCard header={header} headerTools={headerTools}>
                {addBlockModal()}
                {addFrontInfoModal()}
                <BlockListSortable apiData={apiData} setApiData={setApiData} apiUrl={apiUrl} />
            </ListingCard>
        </DefaultLayout>
    );
}

function BlockListSortable({ apiData, setApiData, apiUrl }) {
    const { slug, selection_id } = useParams();
    const [showModal, setShowModal] = useState(false);
    const [selectedBlock, setSelectedBlock] = useState(null);
    const { t } = useTranslation();
    const { api_post } = useRequest();

    const handleDeleteBlock = () => {
        api_post(null, apiUrl, {
            params: { action: "delete_landing_block", id: selectedBlock },
            then: (resp) => {
                if (resp.status === "ok") {
                    setApiData(resp);
                    setShowModal(false);
                }
            },
            finally: () => setSelectedBlock(null),
        });
    };

    const ConfirmModal = () => (
        <DevModal
            show={showModal}
            onHide={() => setShowModal(false)}
            header={t("Удаление Блока")}
            body={t("Подтвердите удаление блока")}
            footer={
                <>
                    <DevForm.Button variant="primary" name="confirm" onClick={handleDeleteBlock}>
                        {t("Да")}
                    </DevForm.Button>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        {t("Отмена")}
                    </Button>
                </>
            }
        />
    );

    return (
        <>
            <ConfirmModal />
            <DndTable
                apiData={apiData}
                setApiData={setApiData}
                apiUrl={apiUrl}
                tds={(el) => (
                    <>
                        <td style={{ width: "30%" }}>
                            <Link
                                to={url_reverse("admin:event:landing_block:games", {
                                    slug,
                                    selection_id,
                                    block_id: el.block.id,
                                })}
                            >
                                {LandingBlockTypes[el.block.scheme]}
                                {el.landing_block_name === "" ? "" : " - "}
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: el.landing_block_name.replace(
                                            /<p>/g,
                                            '<p style="display:inline;margin:0;">'
                                        ),
                                    }}
                                />
                            </Link>
                        </td>
                        <td>
                            <Awesome
                                type="trash-o"
                                color="red"
                                onClick={() => {
                                    setSelectedBlock(el.id);
                                    setShowModal(true);
                                }}
                            />
                        </td>
                    </>
                )}
            />
        </>
    );
}
